import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Box, Link, Paper, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/logo.jpg';
import '../index.css';

const DoctorSignUp = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState({});
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const handleSignUp = async (e) => {
        e.preventDefault();
        const newError = {};
        if (!validateEmail(email)) {
            newError.email = 'Correo electrónico no es válido';
        }
        if (password !== confirmPassword) {
            newError.passwordMatch = 'Las contraseñas no coinciden';
        }
        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/api/register`, {
                username,
                email,
                password
            });
            setSuccess(response.data.message);
            setError({});
            // Redirigir al usuario a la página de inicio de sesión después del registro exitoso
            navigate('/login');
        } catch (error) {
            setError({ server: error.response?.data?.message || 'Error al registrar el usuario' });
            setSuccess('');
        }
    };

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleClickShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

    const validateEmail = (email) => {
        // Expresión regular para validar el correo electrónico
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return re.test(String(email).toLowerCase());
    };

    const handleBlurEmail = () => {
        if (!validateEmail(email)) {
            setError((prev) => ({ ...prev, email: 'Correo electrónico no es válido' }));
        } else {
            setError((prev) => ({ ...prev, email: '' }));
        }
    };

    const handleBlurPassword = () => {
        if (password !== confirmPassword) {
            setError((prev) => ({ ...prev, passwordMatch: 'Las contraseñas no coinciden' }));
        } else {
            setError((prev) => ({ ...prev, passwordMatch: '' }));
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2,backgroundColor: '#f6f8e4'}}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={logo} alt="Logo del Consultorio" style={{ width: 100, marginBottom: 20 }} />
                    <Typography component="h1" variant="h5">Registrar Médico</Typography>
                    <form onSubmit={handleSignUp} style={{ width: '100%', marginTop: 1 }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="Nombre de Usuario"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            error={!!error.server}
                            helperText={error.server ? error.server : ''}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo Electrónico"
                            name="email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onBlur={handleBlurEmail}
                            error={!!error.email}
                            helperText={error.email ? error.email : ''}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Contraseña"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onBlur={handleBlurPassword}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="confirmPassword"
                            label="Confirmar Contraseña"
                            type={showConfirmPassword ? 'text' : 'password'}
                            id="confirmPassword"
                            autoComplete="confirm-password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            onBlur={handleBlurPassword}
                            error={!!error.passwordMatch}
                            helperText={error.passwordMatch ? error.passwordMatch : ''}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle confirm password visibility"
                                            onClick={handleClickShowConfirmPassword}
                                            edge="end"
                                        >
                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        {success && (
                            <Typography color="primary" variant="body2">
                                {success}
                            </Typography>
                        )}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: 3, marginBottom: 2 }}
                        >
                            Registrarse
                        </Button>
                    </form>
                    <Link component={RouterLink} to="/login" variant="body2" sx={{ marginTop: 2 }}>
                        ¿Ya tienes una cuenta? Iniciar Sesión
                    </Link>
                </Box>
            </Paper>
        </Container>
    );
};

export default DoctorSignUp;
